<template>
    <div class="srm-advance">
        <el-input
            v-model="value"
            :placeholder="params.name"
            :disabled="disabled"
            @clear="clear"
            :clearable="clearable"
            @input="input">
            <el-button
                slot="append"
                :icon="icon"
                @click="show"
                :disabled="disabled"
            ></el-button>
        </el-input>
        <advance-dialog ref="advanceDialog" :pageSizes="pageSizes" :mValue="mValue" :mValueList="mValueList" :mCode="mCode" :defaultValue="defaultValue" :max="max" :customClass="customClass"
            @confirm="detaliSearchSure"></advance-dialog>
    </div>
</template>

<script>
import advanceDialog from '../srmAdvanceDialog/index.vue';
export default {
    components: { advanceDialog },
    props: {
        params: Object,
        mValue: [String, Number],
        mCode: [String, Number],
        mValueList: {
            type: Array,
            default() {
                return [];
            }
        },
        clearable: {
            type: Boolean,
            default: true
        },
        max: {
            type: Number,
            default() {
                return 0;
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        pageSizes: {
            type: Array,
            default(){
                return []
            }
        },
        formData: {
            type: Object,
            default() {
                return {};
            }
        },
        defaultValue: {
            type: String,
            default() {
                return '';
            }
        },
        customClass: {
            type: String,
            default() {
                return '';
            }
        },
        icon: {
            type: String,
            default() {
                return 'el-icon-search';
            }
        },
    },
    data() {
        return {
            value: ''
        };
    },
    created() {
        this.value = this.mValue;
    },
    watch: {
        mValue() {
            this.value = this.mValue;
        }
    },
    methods: {
        input() {
            if (!this.clearable) {
                this.value = this.mValue;
                return false;
            }
            const obj = {};
            this.params.cbParams.forEach(item => {
                var arr = item.split('#');
                obj[arr[arr.length - 1]] = '';
            });
            this.value = '';
            this.$emit('getAdvanceValue', obj);
        },
        show() {
            const current = this.params;
            const advanceCascade = {};
            if (current.advanceCascade && Object.prototype.toString.call(current.advanceCascade) === '[object String]') {
                let advanceArray = [];
                advanceArray = current.advanceCascade.split(',');
                advanceArray.map((item) => {
                    let { 0: sourceProp, 1: destProp } = item.split('#');
                    destProp = destProp || sourceProp;
                    advanceCascade[destProp] = this.formData[sourceProp];
                });
            }
            const { mode, advanceRequire } = current;
            if (advanceRequire && advanceRequire.length > 0) {
                let flag = true;
                advanceRequire.forEach(ad => {
                    if (!this.formData[ad.prop]) {
                        flag = false;
                        this.$message.warning(ad.message);
                    }
                });
                if (!flag) { return false; }
            }
            if (current.rule) {
                const { message, validate } = current.rule;
                if (validate && typeof validate === 'function' && !validate()) {
                    this.$message.warning(message || '校验不通过，点击失效');
                    return false;
                }
            }
            this.$refs.advanceDialog.show(true, current, advanceCascade, mode);
        },
        detaliSearchSure(data) {
            this.value = data[this.params.value];
            this.$emit('getAdvanceValue', data);
        },
        clear() {
            this.$emit('clear', '');
        }
    }
};
</script>

<style lang="less" scoped>
.srm-advance {
    /deep/ .el-input-group__append .el-button {
        padding: 7px 14px;
    }
}
</style>
